const akceUsageQuestions = 
  [
    {
      question: "What is the difference between a member and a non-member?",
      answer:
        "Members are able to access the full range of our services, including our online resources, and are entitled to vote at our Annual General Meeting. Non-members are able to access our online resources, but are not entitled to vote at our Annual General Meeting.",
    },
    {
      question: "What is the difference between a member and a non-member?",
      answer:
        "Members are able to access the full range of our services, including our online resources, and are entitled to vote at our Annual General Meeting. Non-members are able to access our online resources, but are not entitled to vote at our Annual General Meeting.",
    },
    {
      question: "What is the difference between a member and a non-member?",
      answer:
        "Members are able to access the full range of our services, including our online resources, and are entitled to vote at our Annual General Meeting. Non-members are able to access our online resources, but are not entitled to vote at our Annual General Meeting.",
    },
    {
      question: "What is the difference between a member and a non-member?",
      answer:
        "Members are able to access the full range of our services, including our online resources, and are entitled to vote at our Annual General Meeting. Non-members are able to access our online resources, but are not entitled to vote at our Annual General Meeting.",
    },
    {
      question: "What is the difference between a member and a non-member?",
      answer:
        "Members are able to access the full range of our services, including our online resources, and are entitled to vote at our Annual General Meeting. Non-members are able to access our online resources, but are not entitled to vote at our Annual General Meeting.",
    },
];

export default akceUsageQuestions;
